export default __webpack_public_path__ + "static/media/photo3.441c1e60.jpg";